import { Alert, IconButton, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import { useGet } from "../Hooks/useFetch";

const MaintenanceBanner = () => {
  const [open, setOpen] = useState(false);
  const [response, error, loading, apiGet, abort] = useGet();

  useEffect(() => {
    // Fetch status once on mount
    apiGet("/api/auth/status", false);
  }, []);

  useEffect(() => {
    if (response) {
      // Check if in notice period and show banner
      if (response.isInNotice && !response.isInOutage) {
        // Check if user has dismissed this notice before
        const dismissed = sessionStorage.getItem("maintenanceNoticeDismissed");
        if (!dismissed) {
          setOpen(true);
        }
      }
    }
  }, [response]);

  const handleClose = () => {
    setOpen(false);
    // Remember that user dismissed the notice for this session
    sessionStorage.setItem("maintenanceNoticeDismissed", "true");
  };

  // Don't render if no response or not in notice period
  if (!response || !response.isInNotice || response.isInOutage) {
    return null;
  }

  return (
    <Collapse in={open}>
      <Alert
        severity="warning"
        sx={{
          // mb: 2,
          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {response.noticeMessage}
      </Alert>
    </Collapse>
  );
};

export default MaintenanceBanner;
